<div class="news mt-4">
  <section-header [data]="dataHeader"> </section-header>
  <div
    class="card-container d-flex flex-row col-md-12 col-sm-12 justify-content-center"
  >
    <a
      target="_blank"
      *ngFor="let card of cardsData"
      [routerLink]="['/noticias', card.id]"
    >
      <news-card class="no-margin" [cardInfo]="card"></news-card>
    </a>
  </div>
</div>
